module.exports = __webpack_public_path__ + "dabed92fc36c55a98af344026be239e6.png";